import { Group, Tooltip } from '@mantine/core';

import { FRAMEWORK_LOGO_ENDPOINT } from '@/config/endpoint';
import Image from 'next/image';
import { imageOpt } from '@/utils/images';
import themeVariables from '@/styles/themeVariables';
import { useRouter } from 'next/navigation';

const TechstackAvatarGroup = ({
  techstackIds = [],
  disableClick = false,
  hideTooltip = false,
  size = 36,
  index = 4,
}: {
  techstackIds: any;
  disableClick?: boolean;
  hideTooltip?: boolean;
  size?: number;
  index?: number;
}) => {
  const { push: navigate } = useRouter();

  const goTechstack = (techstackId) => (e) => {
    if (!disableClick) {
      e.stopPropagation();
      e.preventDefault();
      navigate(`/techstack/detail/${techstackId}`);
    }
  };

  return (
    <>
      <Group spacing={6}>
        {techstackIds?.slice(0, index).map((techstackId) => (
          <Tooltip
            key={techstackId}
            multiline
            withArrow
            hidden={hideTooltip}
            arrowSize={6}
            label={techstackId}
            color={themeVariables.colors.gray}
            sx={{ fontWeight: 'normal' }}
          >
            <Group
              sx={{
                overflow: 'hidden',
                borderRadius: 10,
                outline: '1px solid rgba(0, 0, 0, 0.05)',
                background: '#FFF',
              }}
            >
              <Image
                src={imageOpt(
                  `${FRAMEWORK_LOGO_ENDPOINT}/${techstackId}.png`,
                  100
                )}
                width={size}
                height={size}
                alt={`${techstackId}-image`}
                onClick={goTechstack(techstackId)}
              />
            </Group>
          </Tooltip>
        ))}
      </Group>
    </>
  );
};

export default TechstackAvatarGroup;
